import { FilterXSS } from 'xss';
const xssInstance = new FilterXSS({
  whiteList: {
    p: ['style'],
    h1: ['style'],
    h2: ['style'],
    h3: ['style'],
    h4: ['style'],
    h5: ['style'],
    h6: ['style'],
    div: ['style'],
    ul: ['style'],
    ol: ['style'],
    li: ['style'],
    blockquote: ['style'],
    pre: ['style'],
    code: ['style'],
    table: ['style'],
    thead: ['style'],
    tbody: ['style'],
    tfoot: ['style'],
    tr: ['style'],
    th: ['style'],
    td: ['style'],
    br: ['style'],

    // 常用内联标签
    span: ['style'],
    b: ['style'],
    i: ['style'],
    u: ['style'],
    strong: ['style'],
    em: ['style'],
    del: ['style'],
    mark: ['style'],
    sub: ['style'],
    sup: ['style'],
    img: ['style', 'src', 'alt'],
    video: ['style', 'src', 'controls', 'autoplay', 'loop', 'muted', 'poster', 'width', 'height'],
    source: ['style', 'src', 'type'],
    a: ['style', 'href', 'target'],
  },
});
export default xssInstance;
